import Localization from "../config/localization/Localization";

export function debounce(callback, wait) {
    let timeout = null
    let initialCall = true

    return function() {

        const next = () => {
            callback.apply(this, arguments)
            timeout = null
        }

        if(initialCall){
            initialCall = false
            next()
        }

        clearTimeout(timeout)
        timeout = setTimeout(next, wait)
    }
}

export function removeHtmlTagsFromString(string){
    let strippedString = string.replace(/(<([^>]+)>)/gi, "");
    const tagsRegEx = /&(nbsp|amp|quot|lt|gt);/g;
    const translate = {
        "nbsp": "",
        "amp" : "&",
        "quot": "\"",
        "lt"  : "<",
        "gt"  : ">"
    };
    strippedString = strippedString.replace(tagsRegEx, (match, entity) => {
        return translate[entity]
    })
    return strippedString;
}

export function getLocaleDateTimeString(dateTimeUtc, lowerCase, localizationCode){
    if (!dateTimeUtc) {
        return null;
    }

    const dateTime = new Date(dateTimeUtc);
    const todayString = Localization[localizationCode]['speechBubble.dateTime.today'];
    const atString = Localization[localizationCode]['speechBubble.dateTime.at'];

    let result = null;

    // Check if its the same day
    if ((new Date()).toLocaleDateString() === dateTime.toLocaleDateString()) {
        result = todayString;
    } else {
        result = dateTime.toLocaleDateString();
    }

    result = result + ' ' + atString + ' ' + dateTime
        .toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', hour12: false})
        .replace('AM', '')
        .replace('PM', '');

    if (lowerCase) {
        result = result.toLowerCase();
    }

    return result;
};
